import { motion } from 'framer-motion';
import { FaLaptopCode, FaMobileScreen, FaCloud, FaDatabase, FaRocket } from 'react-icons/fa6';

export default function HeroAnimatedIcons() {
  // Animation for floating effect
  const floatingAnimation = {
    y: [0, -15, 0],
    transition: {
      duration: 4,
      repeat: Infinity,
      ease: "easeInOut"
    }
  };

  const reverseFloatingAnimation = {
    y: [0, 15, 0],
    transition: {
      duration: 5,
      repeat: Infinity,
      ease: "easeInOut"
    }
  };

  const pulseAnimation = {
    scale: [1, 1.05, 1],
    transition: {
      duration: 3,
      repeat: Infinity,
      ease: "easeInOut"
    }
  };

  return (
    <div className="relative w-full max-w-[500px] aspect-square mx-auto flex items-center justify-center">
      {/* Background glowing circles */}
      <motion.div 
        animate={pulseAnimation}
        className="absolute inset-0 bg-gradient-to-tr from-primary/20 to-screens/20 dark:from-[#0D6EFD]/15 dark:to-[#0D6EFD]/10 rounded-full blur-3xl"
      />
      
      <motion.div 
        animate={{ rotate: 360 }}
        transition={{ duration: 60, repeat: Infinity, ease: "linear" }}
        className="absolute inset-4 border-2 border-dashed border-primary/20 dark:border-[#0D6EFD]/20 rounded-full"
      />
      
      <motion.div 
        animate={{ rotate: -360 }}
        transition={{ duration: 40, repeat: Infinity, ease: "linear" }}
        className="absolute inset-16 border border-screens/30 dark:border-[#0D6EFD]/20 rounded-full"
      />

      {/* Main Central Icon */}
      <motion.div 
        animate={floatingAnimation}
        className="relative z-10 w-40 h-40 bg-white dark:bg-dark-card backdrop-blur-xl rounded-3xl shadow-lg dark:shadow-[0_0_50px_rgba(13,110,253,0.2)] flex items-center justify-center border border-gray-100 dark:border-[#0D6EFD]/30"
      >
        <div className="absolute inset-0 bg-gradient-to-br from-blue-50 dark:from-[#0D6EFD]/10 to-transparent rounded-3xl" />
        <FaLaptopCode className="text-7xl text-primary dark:text-screens drop-shadow-md dark:drop-shadow-[0_0_15px_rgba(255,183,3,0.5)]" />
      </motion.div>

      {/* Orbiting / Floating Icons */}
      {/* Top Right */}
      <motion.div 
        animate={reverseFloatingAnimation}
        className="absolute top-[15%] right-[15%] z-20 w-20 h-20 bg-screens rounded-2xl shadow-xl flex items-center justify-center"
        style={{ animationDelay: '0.5s' }}
      >
        <FaMobileScreen className="text-3xl text-white" />
      </motion.div>

      {/* Bottom Right */}
      <motion.div 
        animate={floatingAnimation}
        className="absolute bottom-[20%] right-[10%] z-20 w-16 h-16 bg-white dark:bg-dark-card backdrop-blur-md rounded-2xl shadow-lg border border-gray-100 dark:border-[#0D6EFD]/20 flex items-center justify-center"
        style={{ animationDelay: '1.5s' }}
      >
        <FaDatabase className="text-2xl text-primary dark:text-[#0D6EFD]" />
      </motion.div>

      {/* Top Left */}
      <motion.div 
        animate={floatingAnimation}
        className="absolute top-[25%] left-[10%] z-20 w-16 h-16 bg-white dark:bg-dark-card backdrop-blur-md rounded-full shadow-lg border border-gray-100 dark:border-[#0D6EFD]/20 flex items-center justify-center"
        style={{ animationDelay: '1s' }}
      >
        <FaCloud className="text-2xl text-primary dark:text-[#0D6EFD]" />
      </motion.div>

      {/* Bottom Left */}
      <motion.div 
        animate={reverseFloatingAnimation}
        className="absolute bottom-[25%] left-[15%] z-20 w-24 h-24 bg-gradient-to-br from-primary to-primary/80 dark:from-[#0D6EFD] dark:to-[#1E40AF] rounded-2xl shadow-xl shadow-primary/30 dark:shadow-[#0D6EFD]/30 flex items-center justify-center"
        style={{ animationDelay: '2s' }}
      >
        <FaRocket className="text-4xl text-white" />
      </motion.div>
      
      {/* Small Decorative Dots */}
      <motion.div animate={pulseAnimation} className="absolute top-1/4 right-1/3 w-3 h-3 bg-screens rounded-full" />
      <motion.div animate={pulseAnimation} className="absolute bottom-1/3 left-1/4 w-4 h-4 bg-primary/50 rounded-full" />
      <motion.div animate={pulseAnimation} className="absolute bottom-1/4 right-1/4 w-2 h-2 bg-yellow-400 rounded-full" />
    </div>
  );
}
